import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import * as padStart from 'lodash/padStart';
import { LandingSurface, LandingSurfaceType, LandingSurfaceCondition } from '../models/landing-surface.model';
import { ApproachLighting } from '../models/approach-lighting.model';
import { TakeoffLandArea, TrafficPatternDirection, RunwayMarkingsCondition } from '../models/takeoff-land-area.model';
import { isNumeric } from '../../util/helpers';
import { AirportComment, CommentType } from '../models/airport-comment.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { EditRemarkComponent } from '../edit-remark/edit-remark.component';
import { EditRunwayComponent } from '../edit-runway/edit-runway.component';
import { DeleteRemarkComponent } from '../delete-remark/delete-remark.component';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { AirportService } from '../airport.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { DeleteRunwayComponent } from '../delete-runway/delete-runway.component';
import { EditTakeoffLandAreaComponent } from '../edit-takeoff-land-area/edit-takeoff-land-area.component';
import { EditAreaObstacleComponent } from '../edit-area-obstacle/edit-area-obstacle.component';
import { DeleteAreaObstacleComponent } from '../delete-area-obstacle/delete-area-obstacle.component';
import { DeleteTakeoffLandAreaComponent } from '../delete-takeoff-land-area/delete-takeoff-land-area.component';
import { DeleteAreaLightingComponent } from '../delete-area-lighting/delete-area-lighting.component';
import { EditAreaLightingComponent } from '../edit-area-lighting/edit-area-lighting.component';
var RunwayDetailComponent = /** @class */ (function () {
    function RunwayDetailComponent(_businessManagerService, _decimalPipe, _toggleService, _editRemarkDialog, _editRunwayDialog, _deleteRemarkDialog, _snackBar, _airportService, _deleteRunwayDialog, _editTakeoffLandAreaDialog, _deleteTakeoffLandAreaDialog, _editObstacleDialog, _deleteObstacleDialog) {
        this._businessManagerService = _businessManagerService;
        this._decimalPipe = _decimalPipe;
        this._toggleService = _toggleService;
        this._editRemarkDialog = _editRemarkDialog;
        this._editRunwayDialog = _editRunwayDialog;
        this._deleteRemarkDialog = _deleteRemarkDialog;
        this._snackBar = _snackBar;
        this._airportService = _airportService;
        this._deleteRunwayDialog = _deleteRunwayDialog;
        this._editTakeoffLandAreaDialog = _editTakeoffLandAreaDialog;
        this._deleteTakeoffLandAreaDialog = _deleteTakeoffLandAreaDialog;
        this._editObstacleDialog = _editObstacleDialog;
        this._deleteObstacleDialog = _deleteObstacleDialog;
        this.runwayDeleted = new EventEmitter();
        this.Math = Math;
        this.TrafficPatternDirection = TrafficPatternDirection;
        this.LandingSurfaceType = LandingSurfaceType;
    }
    RunwayDetailComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _a.isFlightDeckAdmin = _b.sent();
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(RunwayDetailComponent.prototype, "surfaceWarning", {
        get: function () {
            return !this.runway.paved || this.runway.condition === LandingSurfaceCondition.Fair;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RunwayDetailComponent.prototype, "surfaceDanger", {
        get: function () {
            return this.runway.condition === LandingSurfaceCondition.Poor
                || this.runway.condition === LandingSurfaceCondition.Failed;
        },
        enumerable: true,
        configurable: true
    });
    RunwayDetailComponent.prototype.formatHeading = function (heading) {
        return isNumeric(heading) ? padStart(heading, 3, '0') : '';
    };
    RunwayDetailComponent.prototype.isNumeric = function (value) {
        return isNumeric(value);
    };
    Object.defineProperty(RunwayDetailComponent.prototype, "type", {
        get: function () {
            return LandingSurface.formatLandingSurfaceType(this.runway.type);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RunwayDetailComponent.prototype, "edgeLighting", {
        get: function () {
            return LandingSurface.formatEdgeLighting(this.runway.edgeLighting);
        },
        enumerable: true,
        configurable: true
    });
    RunwayDetailComponent.prototype.getMagneticHeading = function (area) {
        if (isNumeric(area.trueAlignment) && this.isNumeric(this.magVariation)) {
            return this.formatHeading(area.trueAlignment + this.magVariation);
        }
        return '';
    };
    RunwayDetailComponent.prototype.getGradientDirection = function (gradient) {
        if (!isNumeric(gradient)) {
            return '';
        }
        var sign = Math.sign(gradient);
        switch (sign) {
            case 1:
                return 'up';
            case -1:
                return 'down';
            default:
                return '';
        }
    };
    RunwayDetailComponent.prototype.getTrafficPattern = function (area) {
        return TakeoffLandArea.formatTrafficPatternDirection(area.trafficPatDirFixed);
    };
    RunwayDetailComponent.prototype.getMarkings = function (area) {
        if (!area.markingsType) {
            return '';
        }
        if (area.markingsCondition !== null) {
            var condition = TakeoffLandArea.formatRunwayMarkingsCondition(area.markingsCondition);
            return area.markingsType + (", in " + condition + " condition");
        }
        return area.markingsType;
    };
    RunwayDetailComponent.prototype.getMarkingsWarning = function (area) {
        return area.markingsCondition && (area.markingsCondition === RunwayMarkingsCondition.Fair
            || area.markingsCondition === RunwayMarkingsCondition.Poor);
    };
    RunwayDetailComponent.prototype.getApproachLightingType = function (lighting) {
        return ApproachLighting.formatApproachLightingType(lighting.type);
    };
    RunwayDetailComponent.prototype.getIlsType = function (area) {
        return TakeoffLandArea.formatILSType(area.ilsType);
    };
    RunwayDetailComponent.prototype.formatObstacle = function (obstacle) {
        // Horizontal offset
        var hOffsetStr = '';
        if (obstacle.offsetDirection === 'Both-Sides') {
            hOffsetStr = obstacle.offsetDirection;
        }
        else if (obstacle.centerlineOffset && obstacle.offsetDirection) {
            var offset = this._decimalPipe.transform(obstacle.centerlineOffset);
            hOffsetStr = offset + " ft " + obstacle.offsetDirection + " ft of center";
        }
        // Obstacle height
        var heightStr = '';
        if (obstacle.heightAgl) {
            var height = this._decimalPipe.transform(obstacle.heightAgl);
            heightStr = height + " ft high";
        }
        // Distance from end
        var distanceStr = '';
        if (obstacle.distanceFromEnd) {
            var distance = this._decimalPipe.transform(obstacle.distanceFromEnd);
            distanceStr = distance + " ft from end";
        }
        // Clearance slope
        var slopeStr = '';
        if (obstacle.clearanceSlope) {
            slopeStr = obstacle.clearanceSlope + ":1 clearance slope";
        }
        // Result
        var parts = [
            obstacle.obstacleType,
            hOffsetStr,
            heightStr,
            distanceStr,
            slopeStr
        ];
        return parts.filter(function (v) { return v; }).join(', ');
    };
    RunwayDetailComponent.prototype.getRunwayRemarks = function () {
        var _this = this;
        return this.remarks.filter(function (c) { return c.commentType === CommentType.Runway && c.commentRef === _this.runway.name; });
    };
    RunwayDetailComponent.prototype.getAreaRemarksFAA = function (area) {
        return this.remarks.filter(function (c) { return c.commentType === CommentType.RunwayEnd && c.commentRef === area.name && c.sourceId === 1; });
    };
    RunwayDetailComponent.prototype.getAreaRemarksAM = function (area) {
        return this.remarks.filter(function (c) { return c.commentType === CommentType.RunwayEnd && c.commentRef === area.name && c.sourceId === 5; });
    };
    RunwayDetailComponent.prototype.reloadRemarks = function (identifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var airport;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._airportService.getAirport(identifier, true)];
                    case 1:
                        airport = _a.sent();
                        this.remarks = airport.airportComments;
                        return [2 /*return*/];
                }
            });
        });
    };
    RunwayDetailComponent.prototype.openEditRunwayDialog = function (runway) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogConfig, ERROR_MSG, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                dialogConfig = new MatDialogConfig();
                ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                dialogConfig.data = {
                    airID: runway.airportId,
                    runway: runway,
                    id: null,
                    isNew: false,
                    windowTitle: 'Runway'
                };
                dialogRef = this._editRunwayDialog.open(EditRunwayComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(function (isUpdated) {
                    if (!isUpdated) {
                        return;
                    } // required to handle backdrop click.
                    if (isUpdated.cancelBtnClicked) {
                        return;
                    }
                    // isUpdated.success will be false if there is an error during any of the api calls.
                    if (isUpdated.success) {
                        _this.runway.surfaceReadable = isUpdated.runway.surfaceReadable;
                        _this._snackBar.open('Runway', 'Updated', {
                            duration: 2000
                        });
                    }
                    else {
                        _this._snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    RunwayDetailComponent.prototype.deleteRunway = function (runway) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            runwayId: runway.landingSurfaceId,
            airportId: runway.airportId
        };
        var dialogRef = this._deleteRunwayDialog.open(DeleteRunwayComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this.runwayDeleted.emit(runway.landingSurfaceId);
                _this._snackBar.open('Runway', 'Deleted', {
                    duration: 2000
                });
            }
            else {
                if (isUpdated.error != null) {
                    ERROR_MSG = isUpdated.error.message;
                }
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    RunwayDetailComponent.prototype.openEditRunwayAreaDialog = function (takeoffLandArea) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogConfig, ERROR_MSG, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                dialogConfig = new MatDialogConfig();
                ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                dialogConfig.data = {
                    runwayId: this.runway.landingSurfaceId,
                    airportId: this.runway.airportId,
                    isNew: false,
                    windowTitle: 'Runway Area'
                };
                takeoffLandArea == null ? dialogConfig.data.isNew = true : dialogConfig.data.takeoffLandArea = takeoffLandArea;
                dialogRef = this._editTakeoffLandAreaDialog.open(EditTakeoffLandAreaComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(function (isUpdated) {
                    if (!isUpdated) {
                        return;
                    } // required to handle backdrop click.
                    if (isUpdated.cancelBtnClicked) {
                        return;
                    }
                    // isUpdated.success will be false if there is an error during any of the api calls.
                    if (isUpdated.success) {
                        if (isUpdated.isNew) {
                            _this.runway.takeOffLandAreas.push(isUpdated.takeoffLandArea);
                            _this._snackBar.open('Runway Area', 'Added', {
                                duration: 2000
                            });
                        }
                        else {
                            _this._snackBar.open('Runway Area', 'Updated', {
                                duration: 2000
                            });
                        }
                    }
                    else {
                        _this._snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    RunwayDetailComponent.prototype.deleteTakeoffLandArea = function (takeoffLandArea) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            takeoffLandAreaId: takeoffLandArea.takeoffLandAreaId,
            airportId: this.runway.airportId
        };
        var dialogRef = this._deleteTakeoffLandAreaDialog.open(DeleteTakeoffLandAreaComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                var index = _this.runway.takeOffLandAreas.findIndex(function (n) { return n.takeoffLandAreaId === takeoffLandArea.takeoffLandAreaId; });
                if (index > -1) {
                    _this.runway.takeOffLandAreas.splice(index, 1);
                }
                _this._snackBar.open('Area', 'Deleted', {
                    duration: 2000
                });
            }
            else {
                if (isUpdated.error != null) {
                    ERROR_MSG = isUpdated.error.message;
                }
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    RunwayDetailComponent.prototype.openEditObstacleDialog = function (obstacle, area) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogConfig, ERROR_MSG, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                dialogConfig = new MatDialogConfig();
                ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                dialogConfig.data = {
                    takeoffLandAreaId: area.takeoffLandAreaId,
                    airportId: this.runway.airportId,
                    isNew: false,
                    windowTitle: 'Obstacle'
                };
                obstacle == null ? dialogConfig.data.isNew = true : dialogConfig.data.obstacle = obstacle;
                dialogRef = this._editObstacleDialog.open(EditAreaObstacleComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(function (isUpdated) {
                    if (!isUpdated) {
                        return;
                    } // required to handle backdrop click.
                    if (isUpdated.cancelBtnClicked) {
                        return;
                    }
                    // isUpdated.success will be false if there is an error during any of the api calls.
                    if (isUpdated.success) {
                        if (isUpdated.isNew) {
                            area.obstacles.push(isUpdated.obstacle);
                            _this._snackBar.open('Obstacle', 'Added', {
                                duration: 2000
                            });
                        }
                        else {
                            _this._snackBar.open('Obstacle', 'Updated', {
                                duration: 2000
                            });
                        }
                    }
                    else {
                        _this._snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    RunwayDetailComponent.prototype.deleteObstacle = function (obstacle, area) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            obstacleId: obstacle.obstacleId,
            airportId: this.runway.airportId
        };
        var dialogRef = this._deleteTakeoffLandAreaDialog.open(DeleteAreaObstacleComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                var index = area.obstacles.findIndex(function (o) { return o.obstacleId === obstacle.obstacleId; });
                if (index > -1) {
                    area.obstacles.splice(index, 1);
                }
                _this._snackBar.open('Obstacle', 'Deleted', {
                    duration: 2000
                });
            }
            else {
                if (isUpdated.error != null) {
                    ERROR_MSG = isUpdated.error.message;
                }
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    RunwayDetailComponent.prototype.openEditLightingDialog = function (lighting, area) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogConfig, ERROR_MSG, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                dialogConfig = new MatDialogConfig();
                ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                dialogConfig.data = {
                    runwayId: this.runway.landingSurfaceId,
                    airportId: this.runway.airportId,
                    takeoffLandAreaId: area.takeoffLandAreaId,
                    isNew: false,
                    windowTitle: 'Runway Lighting'
                };
                lighting == null ? dialogConfig.data.isNew = true : dialogConfig.data.lighting = lighting;
                dialogRef = this._editObstacleDialog.open(EditAreaLightingComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(function (isUpdated) {
                    if (!isUpdated) {
                        return;
                    } // required to handle backdrop click.
                    if (isUpdated.cancelBtnClicked) {
                        return;
                    }
                    // isUpdated.success will be false if there is an error during any of the api calls.
                    if (isUpdated.success) {
                        if (isUpdated.isNew) {
                            area.approachLighting.push(isUpdated.lighting);
                            _this._snackBar.open('Lighting', 'Added', {
                                duration: 2000
                            });
                        }
                        else {
                            _this._snackBar.open('Lighting', 'Updated', {
                                duration: 2000
                            });
                        }
                    }
                    else {
                        _this._snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    RunwayDetailComponent.prototype.deleteLighting = function (lighting, area) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            lightingId: lighting.lightingId,
            airportId: this.runway.airportId
        };
        var dialogRef = this._deleteTakeoffLandAreaDialog.open(DeleteAreaLightingComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                var index = area.approachLighting.findIndex(function (l) { return l.lightingId === lighting.lightingId; });
                if (index > -1) {
                    area.approachLighting.splice(index, 1);
                }
                _this._snackBar.open('Lighting', 'Deleted', {
                    duration: 2000
                });
            }
            else {
                if (isUpdated.error != null) {
                    ERROR_MSG = isUpdated.error.message;
                }
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    RunwayDetailComponent.prototype.openEditRunwayRemarkDialog = function (index, area) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogConfig, ERROR_MSG, defaultRemark, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                dialogConfig = new MatDialogConfig();
                ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                dialogConfig.width = '60%';
                defaultRemark = {
                    commentType: AirportComment.parseCommentType('Runway-End'),
                    commentRef: area.name
                };
                dialogConfig.data = {
                    airID: this.airportId,
                    id: null,
                    isNew: false,
                    remark: defaultRemark,
                    windowTitle: 'Runway Comment'
                };
                index == null ? dialogConfig.data.isNew = true : dialogConfig.data.remark = this.getAreaRemarksAM(area)[index];
                dialogConfig.data['airID'] = this.airportId;
                dialogConfig.width = '60%';
                dialogRef = this._editRemarkDialog.open(EditRemarkComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(function (isUpdated) {
                    if (!isUpdated) {
                        return;
                    } // required to handle backdrop click.
                    if (isUpdated.cancelBtnClicked) {
                        return;
                    }
                    // isUpdated.success will be false if there is an error during any of the api calls.
                    if (isUpdated.success) {
                        if (isUpdated.isNew) {
                            _this.remarks.push(isUpdated.remark);
                            _this._snackBar.open('Runway Comment', 'Added', {
                                duration: 2000
                            });
                        }
                        else {
                            _this._snackBar.open('Runway Comment', 'Updated', {
                                duration: 2000
                            });
                        }
                        _this.reloadRemarks(_this.identifier);
                    }
                    else {
                        _this._snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    RunwayDetailComponent.prototype.deleteRunwayRemark = function (index, area) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            airportId: this.airportId,
            remarkId: this.getAreaRemarksAM(area)[index].id
        };
        var dialogRef = this._deleteRemarkDialog.open(DeleteRemarkComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this._snackBar.open('Runway Comment', 'Deleted', {
                    duration: 2000
                });
                // this.airport.airportComments.splice(index, 1);
                _this.reloadRemarks(_this.identifier);
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return RunwayDetailComponent;
}());
export { RunwayDetailComponent };
